var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1739_40362",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1739_40362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.49998 20C5.11794 20 3.9391 19.5205 2.96345 18.5617C1.98782 17.6029 1.5 16.4311 1.5 15.0461C1.5 13.8038 1.89968 12.7112 2.69905 11.7683C3.49842 10.8253 4.48976 10.2667 5.67308 10.0923C5.99359 8.59744 6.74519 7.375 7.92788 6.425C9.11056 5.475 10.4679 5 12 5C13.8107 5 15.3467 5.63066 16.608 6.89198C17.8693 8.15328 18.5 9.68928 18.5 11.5V12H18.8077C19.8615 12.0821 20.7403 12.5058 21.4442 13.2712C22.148 14.0365 22.5 14.9461 22.5 16C22.5 17.1153 22.1153 18.0609 21.3461 18.8365C20.5769 19.6121 19.6346 20 18.5192 20H13.0577C12.5525 20 12.125 19.825 11.775 19.475C11.425 19.125 11.25 18.6974 11.25 18.1923V12.7153L9.39998 14.5346L8.34615 13.4904L12 9.83655L15.6538 13.4904L14.6 14.5346L12.75 12.7153V18.1923C12.75 18.2692 12.782 18.3397 12.8461 18.4038C12.9102 18.4679 12.9807 18.5 13.0577 18.5H18.5C19.2 18.5 19.7916 18.2583 20.275 17.775C20.7583 17.2916 21 16.7 21 16C21 15.3 20.7583 14.7083 20.275 14.225C19.7916 13.7416 19.2 13.5 18.5 13.5H17V11.5C17 10.1166 16.5125 8.93748 15.5375 7.96248C14.5625 6.98748 13.3833 6.49998 12 6.49998C10.6166 6.49998 9.43748 6.98748 8.46248 7.96248C7.48748 8.93748 6.99998 10.1166 6.99998 11.5H6.48075C5.53332 11.5 4.71633 11.8416 4.02978 12.525C3.34324 13.2083 2.99998 14.0333 2.99998 15C2.99998 15.9666 3.34164 16.7916 4.02498 17.475C4.70831 18.1583 5.53331 18.5 6.49998 18.5H8.99998V20H6.49998Z",
    fill: "#183883"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud_upload.ec0d2fa4f288056f8285a178baa81990.svg";
export { ForwardRef as ReactComponent };